var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"sidebat"},[_c('Sidebar')],1),_c('div',{staticClass:"warpper"},[_c('keep-alive',[(_vm.$route.name === 'article-List')?_c('router-view'):_vm._e()],1),(_vm.$route.name !== 'article-List')?_c('router-view'):_vm._e()],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }